import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Select from "react-select";
import { toast } from "react-toastify";
import {
    Card,
    CardBody,
    CardHeader,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    Col,
    Row,
    UncontrolledTooltip,
    UncontrolledPopover,
    PopoverHeader,
    PopoverBody,
} from "reactstrap";
import SupplierService from "src/modules/3rd-party-management/apis/common/SupplierService";
import { connect } from "react-redux";
import {
    API_BASE_URL,
    DDSActivityTypes
} from "src/modules/3rd-party-management/constants";
import CommoditiesList from "./components/CommoditiesList";
import CommonService from "src/modules/3rd-party-management/apis/common/CommonService";
import { useHistory } from "react-router-dom";
import axios from "axios";
import LocalizedPhoneInput from "src/modules/3rd-party-management/components/LocalizedPhoneInput";
import DDSSubmitConfirmModal from "./DDSSubmitConfirmModal";
import TraceApiKeyCard from "./components/TraceApiKeyCard";

const QuestionsMap = {
    'x4r7m1t9v5k2c3n8p6z0wqdyhglejua': 'address_country',
    'r8v1m6x3t9k5c2n4p7w0zqdhyglejua': 'address_city',
    't5r2m9v8k1x3c7n4p0w6zqldyhgejua': 'address_postal',
    'c2n9v5x7t3r1k8m4p6w0zqdjhygleua': 'address_else',
    'q8t2m9v1r4x6c3k7w5n0zpldyhgejba': 'identifier_type',
    'h9p1x3k5v7t2m8r0c6n4zqgwlydeuaf': 'identifier_value',
    'n4d2j9x7c1r5v8m0t3k6wqzghyuepba': 'internal_ref',
    'f1z3r7v9x2k4c8m0t5n6pqdghlyuwae': 'activity_type',
    'a4v9x1m6t2r7k3c5n8p0wqdyhzglefu': 'comment',
    'l5m1v9x4r2t7k3c8n6p0wqdyhzgejua': 'activity_country',
    'g9r3t1m8v5x2k7c4n6p0zqwyhldefua': 'crossed_country',
    'g9r3t1m8d522k7c4n6p0zqwyhldefua': 'exited_country',
    'y8r2m9t1v4x3k5c7n6p0zqwdhglefua': 'products',
    'm6v3t1r9x2k7c5n8w4z0pqjhydluega': 'operator_name',
    'z7x2v9r1m6t3k5c8n4p0wqdyhlejgua': 'operator_email',
    'd1r4m9t7v3x2k6c5n8p0zqwyhglefua': 'operator_phone',
    'k6t1r8x3m5v2c9n7p4w0zqdyhglefua': 'address_else'
}


const DDSQuestionnaire = ({
    t,
    user,
    token,
    supplierId,
    reportCaseId,
    questions
}) => {
    const [ isCreateNewFormSubmiting, setIsCreateNewFormSubmiting ] = useState(false);
    const [ products, setProducts ] = useState([]);
    const [fields, setFields] = useState({
        operator_email: user.email,
        operator_phone: user.phone_number,
        address_id: null,
        address_country: null,
        address_city: null,
        address_postal: null,
        address_else: null,
        identifier_type: 'EORI',
        identifier_value: null,
        internal_ref: null,
        activity_type: '4f2fjqu7e52v4slrhctgp8pm84uy9mog',
        comment: null,
        activity_country: null,
        crossed_country: null,
        exited_country: null
    });
    const [ errors, setErrors ] = useState([]);
    const [ showConfirm, setShowConfirm ] = useState(false);

    const history = useHistory();
    const fieldsFirstInit = useRef();

    const {
        data: ownCompanyInfos
    } = useQuery({
        queryKey: [
            '3rd-party-management-supplier-details-basic-infos',
            supplierId
        ],
        queryFn: async () => {
            const service = SupplierService.getInstance();

            return await service.fetchBasicInfos(supplierId, {});
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t('An error occurred while fetching the basic information.'), {
                type: 'error',
            });
        }
    });

    const {
        data: countriesData,
        isFetching: fetchingCountries
    } = useQuery({
        queryKey: ['3rd-party-management-fetch-countries-list-query'],
        queryFn: async () => {
            const service = CommonService.getInstance();

            return await service.fetchCountries();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t('An error occurred while fetching countries list.'), {
                type: 'error',
            });
        }
    });

    const formIsValid = () => {
        const currentErrors = [];

        if (!fields.operator_email) {
            currentErrors.push('operator_email');
        }

        if (!fields.operator_phone) {
            currentErrors.push('operator_phone');
        }

        if (!fields.operator_phone) {
            currentErrors.push('operator_phone');
        }

        if (!fields.identifier_value) {
            currentErrors.push('identifier_value');
        }

        if (!fields.address_id) {
            currentErrors.push('address_id');
        }
        
        if (currentErrors.length > 0) {
            setErrors(currentErrors);
            return false;
        }
        else {
            setErrors([]);
            return true;
        }
    }

    const autoSave = async (result) => {
        return await axios.post(`${API_BASE_URL}/report/${ reportCaseId }/edit`, {
            questionAnswers: result,
            questionnaireType: 'ddssubmission'
        }, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});
    }

    const submitQuestionnaire = async () => {
        const result = questions.map((question) => {
            if (QuestionsMap[question.front_id] === 'products') {
                return {
                    question: question.id,
                    answer: [
                        {
                            title: products.map((p) => `${p.name.class} - ${p.name.name}`).join(', ')
                        }
                    ]
                }
            }

            if (QuestionsMap[question.front_id] === 'operator_name') {
                return {
                    question: question.id,
                    answer: [
                        {
                            title: ownCompanyInfos.name
                        }
                    ]
                }
            }

            if (question.type !== 'radiobox') {
                return {
                    question: question.id,
                    answer: [
                        {
                            title: fields[QuestionsMap[question.front_id]]
                        }
                    ]
                }
            }
            
            const option = (question.options || []).find((op) => op.front_id === fields[QuestionsMap[question.front_id]])

            return {
                question: question.id,
                answer: [
                    {
                        title: option?.title,
                        value: option?.id
                    }
                ]
            }
        });

        setIsCreateNewFormSubmiting(true);

        await autoSave(result);

        axios.post(`${API_BASE_URL}/report/${reportCaseId}/submit`, result, {
			headers: {
				Authorization: `Bearer ${token}`,
			}
		})
		.then(() => {
			toast(t('Request Submitted'), {
				type: 'success',
			});

			setTimeout(() => {
                history.push(`/admin/guard/carriers/${supplierId}/details?tab=reports`)
			}, 250);
		})
		.catch(() => {
			toast(t('Error!'), {
				type: 'error',
			});
		})
		.finally(() => {
			setIsCreateNewFormSubmiting(false);
		});
    }

    const handleSubmit = () => {
        if(!formIsValid()) {
            return window.scrollTo({
                top: 200,
                behavior: "smooth",
            });
        }

        setShowConfirm(true)
    };

    const countries = useMemo(() => {
        return (countriesData || []).map((country) => {
            return {
                value: country.id,
                label: t(country.name),
                code: country.code,
            };
        });
    }, [countriesData, t])

    const renderActivityTypeQuestions = () => {
        if(fields.activity_type === '4f2fjqu7e52v4slrhctgp8pm84uy9mog') { // import
            return (
                <Row>
                    <Col sm="12" md="6">
                        <FormGroup className="mb-3">
                            <Label for="activity_country">
                                {t('In which country is the import activity taking place?')}
                                <span
                                    id="activity-country-help"
                                >
                                    <i
                                        className="ri-information-line text-secondary"
                                        aria-hidden="true"
                                    />
                                </span>
                            </Label>

                            <UncontrolledTooltip
                                placement="top"
                                target="activity-country-help"
                            >
                                {t('Select the country where the import operation is conducted or recorded.')}
                            </UncontrolledTooltip>

                            <Select
                                isLoading={fetchingCountries}
                                isDisabled={fetchingCountries}
                                id="activity_country"
                                placeholder={t("Select") + "..."}
                                classNamePrefix="select2-selection"
                                options={countries}
                                onChange={(e) => setFields((prev) => ({ ...prev, activity_country: e.code }))}
                            />
                        </FormGroup>
                    </Col>

                    <Col sm="12" md="6">
                        <FormGroup className="mb-3">
                            <Label for="crossed_country">
                                {t('Which country is entered at the border during the import activity?')}

                                <span
                                    id="border-country-help"
                                >
                                    <i
                                        className="ri-information-line text-secondary"
                                        aria-hidden="true"
                                    />
                                </span>
                            </Label>

                            <UncontrolledTooltip
                                placement="top"
                                target="border-country-help"
                            >
                                {t('Choose the country where the goods physically enter the market or customs area.')}
                            </UncontrolledTooltip>

                            <Select
                                isLoading={fetchingCountries}
                                isDisabled={fetchingCountries}
                                id="crossed_country"
                                placeholder={t("Select") + "..."}
                                classNamePrefix="select2-selection"
                                options={countries}
                                onChange={(e) => setFields((prev) => ({ ...prev, crossed_country: e.code }))}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            )
        }

        if(fields.activity_type === 'vdt1wazwqgu5u1wluwwo9onudqrmox8a') { //export
            return (
                <Row>
                    <Col sm="12" md="6">
                        <FormGroup className="mb-3">
                            <Label for="exited_country">
                                {t('Country of Exit')}

                                <span
                                    id="exited-country-help"
                                >
                                    <i
                                        className="ri-information-line text-secondary"
                                        aria-hidden="true"
                                    />
                                </span>
                            </Label>

                            <UncontrolledTooltip
                                placement="top"
                                target="exited-country-help"
                            >
                                {t('Select the country the goods are exported from.')}
                            </UncontrolledTooltip>

                            <Select
                                isLoading={fetchingCountries}
                                isDisabled={fetchingCountries}
                                id="exited_country"
                                placeholder={t("Select") + "..."}
                                classNamePrefix="select2-selection"
                                options={countries}
                                onChange={(e) => setFields((prev) => ({ ...prev, exited_country: e.code }))}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            )
        }

        // Domestic
        return (
            <Row>
                <Col sm="12" md="6">
                    <FormGroup className="mb-3">
                        <Label for="activity_country">
                            {t('In which country is the activity taking place?')}
                            <span
                                id="activity-country-help"
                            >
                                <i
                                    className="ri-information-line text-secondary"
                                    aria-hidden="true"
                                />
                            </span>
                        </Label>

                        <UncontrolledTooltip
                            placement="top"
                            target="activity-country-help"
                        >
                            {t('Select the country where the goods are produced, handled, or moved within national borders.')}
                        </UncontrolledTooltip>

                        <Select
                            isLoading={fetchingCountries}
                            isDisabled={fetchingCountries}
                            id="activity_country"
                            placeholder={t("Select") + "..."}
                            classNamePrefix="select2-selection"
                            options={countries}
                            onChange={(e) => setFields((prev) => ({ ...prev, activity_country: e.code }))}
                        />
                    </FormGroup>
                </Col>
            </Row>
        )
    }

    useEffect(() => {
        if (!fieldsFirstInit.current) {
            return fieldsFirstInit.current = true;
        }

        formIsValid();
    }, [ fields ]);

    useEffect(() => {
        if (ownCompanyInfos?.locations && ownCompanyInfos.locations.length) {
            const firstLocation = ownCompanyInfos.locations[0];

            setFields((prev) => ({
                ...prev,
                address_id: firstLocation.id,
                address_country: firstLocation.countryName,
                address_city: firstLocation.city,
                address_postal: firstLocation.postalCode,
                address_else: firstLocation.address
            }));
        }
    }, [ ownCompanyInfos?.locations ])

    return (
        <div>
            <Card className="mb-3 shadow-sm">
                <CardHeader>
                    {t('Operator Information')}
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col md="12">
                            <FormGroup className="mb-3">
                                <Label>
                                    {t('Name')}:
                                </Label>
                                <div>
                                    {ownCompanyInfos?.name}
                                </div>
                            </FormGroup>
                        </Col>

                        <Col md="12">
                            <Row>
                                <Col md="6" className="mb-3">
                                    <FormGroup>
                                        <Label for="operator_email">
                                            {t('Email')}:
                                        </Label>
                                        <Input
                                            type="text"
                                            name="operator_email"
                                            onChange={(e) => setFields((prev) => ({ ...prev, operator_email: e.target.value }))}
                                            value={fields.operator_email}
                                        />
                                    </FormGroup>
                                    {errors.includes('operator_email') && (
                                        <span className="text-danger mt-1">
                                            {t('This field is required')}
                                        </span>
                                    )}
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6" className="mb-3">
                                    <FormGroup>
                                        <Label for="operator_phone">
                                            {t('Phone')}:
                                        </Label>
                                        <LocalizedPhoneInput
                                            inputClass="w-100"
                                            country={"us"}
                                            inputStyle={{
                                                height: "38px",
                                            }}
                                            disableInitialCountryGuess={false}
                                            disableCountryGuess={false}
                                            onChange={(e) => setFields((prev) => ({ ...prev, operator_phone: e }))}
                                            value={fields.operator_phone}
                                        />
                                    </FormGroup>

                                    {errors.includes('operator_phone') && (
                                        <span className="text-danger mt-1">
                                            {t('This field is required')}
                                        </span>
                                    )}
                                </Col>
                            </Row>
                        </Col>

                        <Col sm="12" md="6">
                            <FormGroup className="mb-3">
                                <Label htmlFor="identifier_type">
                                    {t('What is the identifier type of the operator’s reference number?')}
                                    <span className="text-danger">*</span>
                                    <span
                                        id="typeof-operator-ref-number-help"
                                    >
                                        <i
                                            className="ri-information-line text-secondary"
                                            aria-hidden="true"
                                        />
                                    </span>
                                </Label>

                                <UncontrolledPopover
                                    trigger="hover"
                                    placement="right"
                                    target="typeof-operator-ref-number-help"
                                >
                                    <PopoverHeader>
                                        {t('Operator Reference Type')}
                                    </PopoverHeader>
                                    <PopoverBody>
                                        {t('This field specifies the type of official identifier used to recognize the operator of the activity.')}
                                        {t('The system uses this type to validate the reference number you provide.')}
                                        {t('Common types include')}:<br/>
                                        - <strong>EORI</strong> – {t('Economic Operators Registration and Identification number')}<br/>
                                        - <strong>VAT</strong> – {t('Value Added Tax number')}<br/>
                                        - <strong>DUNS</strong> – {t('Dun & Bradstreet number')}<br/>
                                        - <strong>COMP_REG / COMP_NUM / CIN / TIN</strong> – {t('National company registration or tax numbers')}<br/>
                                        - <strong>GLN</strong> – {t('Global Location Number')}<br/>
                                        - <strong>CBR / REMOS / SHIP_MAN_COMP_IMO / SHIP_REG_OWNER_IMO</strong> – {t('Shipping or maritime identifiers')}<br/>
                                        {t('Select the type that matches the operator’s reference number you entered.')}
                                    </PopoverBody>
                                </UncontrolledPopover>
                        
                                <Input
                                    type="select"
                                    name="identifier_type"
                                    onChange={(e) => setFields((prev) => ({ ...prev, identifier_type: e.target.value }))}
                                    selected='EORI'
                                >
                                    <option value="EORI">
                                        EORI
                                    </option>
                                    <option value="VAT">
                                        VAT
                                    </option>
                                    <option value="CIN">
                                        CIN
                                    </option>
                                    <option value="DUNS">
                                        DUNS
                                    </option>
                                    <option value="COMP_REG">
                                        COMP_REG
                                    </option>
                                    <option value="COMP_NUM">
                                        COMP_NUM
                                    </option>
                                    <option value="CBR">
                                        CBR
                                    </option>
                                    <option value="SHIP_MAN_COMP_IMO">
                                        SHIP_MAN_COMP_IMO
                                    </option>
                                    <option value="SHIP_REG_OWNER_IMO">
                                        SHIP_REG_OWNER_IMO
                                    </option>
                                    <option value="REMOS">
                                        REMOS
                                    </option>
                                    <option value="GLN">
                                        GLN
                                    </option>
                                    <option value="TIN">
                                        TIN
                                    </option>
                                </Input>
                            </FormGroup>
                        </Col>

                        <Col sm="12" md="6" className="mb-3">
                            <FormGroup>
                                <Label htmlFor="identifier_value">
                                    {t('What is the identifier value of the operator’s reference number?')}
                                    <span className="text-danger">*</span>
                                    <span
                                        id="valueof-operator-ref-number-help"
                                    >
                                        <i
                                            className="ri-information-line text-secondary"
                                            aria-hidden="true"
                                        />
                                    </span>
                                </Label>

                                <UncontrolledPopover 
                                    target="valueof-operator-ref-number-help"
                                    trigger="hover"
                                >
                                    <PopoverHeader>{t('Operator Reference Number')}</PopoverHeader>
                                    <PopoverBody>
                                        {t('Enter the actual reference number of the operator that matches the type you selected in the previous field.')}<br/>
                                        {t('This could be an EORI, VAT number, DUNS number, company registration number, or any other official identifier.')}<br/>
                                        {t('Make sure the number is correct so the system can properly validate the operator.')}
                                    </PopoverBody>
                                </UncontrolledPopover>
                                
                                <Input
                                    type="text"
                                    name="identifier_value"
                                    onChange={(e) => setFields((prev) => ({ ...prev, identifier_value: e.target.value }))}
                                />
                            </FormGroup>
                            {errors.includes('identifier_value') && (
                                <span className="text-danger mt-1">
                                    {t('This field is required')}
                                </span>
                            )}
                        </Col>

                        <Col md="12">
                            <FormGroup>
                                <Label>
                                    {t('Address')}:
                                    <span className="text-danger">*</span>
                                </Label>
                                {(ownCompanyInfos?.locations || []).map((addr, idx) => (
                                    <FormGroup check key={idx}>
                                        <Label check>
                                            <Input
                                                type="radio"
                                                name="selectedAddress"
                                                checked={fields.address_id === addr.id}
                                                onChange={() => setFields((prev) => ({ 
                                                    ...prev, 
                                                    address_id: addr.id,
                                                    address_country: addr.countryName,
                                                    address_city: addr.city,
                                                    address_postal: addr.postalCode,
                                                    address_else: addr.address
                                                }))}
                                            />{" "}
                                            {addr.address}, {addr.postalCode} {addr.city}, {t(addr.countryName)}
                                        </Label>
                                    </FormGroup>
                                ))}
                            </FormGroup>
                            {errors.includes('address_id') && (
                                <span className="text-danger mt-1">
                                    {t('This field is required')}
                                </span>
                            )}
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            <CommoditiesList 
                supplierId={supplierId}
                onProductLoaded={(products) => setProducts(products)}
            />

            {/* Submission Form */}
            <Card className="mb-3 shadow-sm">
                <CardHeader>
                    {t('Submit DDS Statement')}
                </CardHeader>
                <CardBody>
                    <Form>
                        <Row>
                            <Col sm="12">
                                <FormGroup className="mb-3">
                                    <Label for="internal_ref">
                                        {t('Internal Reference Number')}
                                        <span
                                            id="internal-reference-number-help"
                                        >
                                            <i
                                                className="ri-information-line text-secondary"
                                                aria-hidden="true"
                                            />
                                        </span>
                                    </Label>

                                    <UncontrolledTooltip
                                        placement="top"
                                        target="internal-reference-number-help"
                                    >
                                        {t('Enter your own reference number to track this DDS statement internally. If you leave it empty, the system will generate one for you automatically. This number is for your records only and is not the official DDS ID.')}
                                    </UncontrolledTooltip>

                                    <Input
                                        id="internal_ref"
                                        onChange={(e) => setFields((prev) => ({ ...prev, internal_ref: e.target.value }))}
                                    />
                                </FormGroup>
                            </Col>

                            <Col sm="12" md="6">
                                <FormGroup className="mb-3">
                                    <Label for="activity_type">
                                        {t('Activity Type')}
                                        <span className="text-danger">*</span>
                                        <span
                                            id="activity-type-help"
                                        >
                                            <i
                                                className="ri-information-line text-secondary"
                                                aria-hidden="true"
                                            />
                                        </span>
                                    </Label>

                                    <UncontrolledTooltip
                                        placement="top"
                                        target="activity-type-help"
                                    >
                                        {t('Select the type of activity you are reporting (e.g., import, export, or domestic trade). The activity type determines the applicable reporting rules.')}
                                    </UncontrolledTooltip>

                                    <Input
                                        type="select"
                                        id="activity_type"
                                        onChange={(e) => setFields((prev) => ({ ...prev, activity_type: e.target.value }))}
                                        selected="4f2fjqu7e52v4slrhctgp8pm84uy9mog"
                                    >
                                        {Object.keys(DDSActivityTypes).map((activityKey) => {
                                            return (
                                                <option value={DDSActivityTypes[activityKey]?.questionnaireFrontId}>
                                                    {t(DDSActivityTypes[activityKey]?.title)}
                                                </option>
                                            )
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>

                            <Col sm="12">
                                { renderActivityTypeQuestions() }
                            </Col>

                            <Col sm="12" md="12">
                                <FormGroup className="mb-3">
                                    <Label for="comment">
                                        {t('Do you have any comments or remarks about this statement?')}
                                        <span
                                            id="comment-help"
                                        >
                                            <i
                                                className="ri-information-line text-secondary"
                                                aria-hidden="true"
                                            />
                                        </span>
                                    </Label>

                                    <UncontrolledTooltip
                                        placement="top"
                                        target="comment-help"
                                    >
                                        {t('Provide any additional notes, clarifications, or special circumstances related to this DDS statement.')}
                                    </UncontrolledTooltip>

                                    <Input
                                        type="textarea"
                                        id="comment"
                                        onChange={(e) => setFields((prev) => ({ ...prev, comment: e.target.value }))}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </CardBody>
            </Card>

            <TraceApiKeyCard 
                apiKey={ownCompanyInfos?.apiKey}
            />

            <Row>
                <Col sm='12' className="d-flex justify-content-end">
                    <Button
                        color="primary"
                        onClick={handleSubmit}
                        disabled={isCreateNewFormSubmiting || !products.length}
                    >
                        {t('Submit DDS')}
                    </Button>
                </Col>
            </Row>

            <DDSSubmitConfirmModal 
                isOpen={showConfirm}
                toggle={() => setShowConfirm(false)}
                onConfirm={submitQuestionnaire}
                isFormSubmiting={isCreateNewFormSubmiting}
            />
        </div>
    );
};

const mapStatetoProps = (state) => {
    const { user, token } = state.Login;

    return {
        token,
        user
    };
};

export default withNamespaces()(
    connect(mapStatetoProps, {})(
        withRouter(DDSQuestionnaire)
    )
); 